/*
 * @Author: cc
 * @LastEditTime: 2021-04-27 16:59:56
 */
/*
 * @Author: cc
 * @LastEditTime: 2021-04-14 19:43:27
 */
/*
 * @Author: cc
 * @LastEditTime: 2021-04-08 16:09:40
 */


const initDataInfo = {
  id: 1,
  mobileBottomImageUrl: "",
  mobileMainImageUrl: "",
  mobileName: "",
  mobileTopImageUrl: "",
  onlineServiceContent: "",
  columnId:1,
  subjectId:1,
  onlineServiceFlag: 1,
  pcBottomImageUrl: "",
  pcMainImageUrl: "",
  pcName: "",
  pcTopImageUrl: "",
  projectId: 604,
  projectLoginPageUrl: "",
  smsTitle: "0",
  unifyPasswordLoginFlag: 1,
  unifyPasswordLoginIndex: 1,
  unifySmsLoginFlag: 1,
  unifySmsLoginIndex: 2,
  verifyLoginMode: 1
}

export interface UserProps{
  type:string,
  name:string,
  avatar:string,
  userId:number | null,
  mobile?:string,
}
export interface InitProps {
  id?: number,
  type?:string,
  mobileBottomImageUrl?:string,
  mobileMainImageUrl?:string,
  columnId?:number,
  subjectId?:number,
  mobileName?:string,
  mobileTopImageUrl?:string,
  onlineServiceContent?:string,
  onlineServiceFlag: 1,
  pcBottomImageUrl?:string,
  pcMainImageUrl?:string,
  pcName?:string,
  pcTopImageUrl?:string,
  projectId?:number,
  projectLoginPageUrl?:string,
  smsTitle?:string,
  unifyPasswordLoginFlag?:number,
  unifyPasswordLoginIndex?:number,
  unifySmsLoginFlag?:number,
  unifySmsLoginIndex?:number,
  verifyLoginMode?:number
}
const InitUserInfo = {
  type:"",
  name: "",
  avatar: "",
  userId:null,
  mobile:""
};
const InitPageInfo = {}

export const InitPageData = (state = InitPageInfo,action:any) =>{
  switch (action.type) {
    case "SET_INIT_PAGE_INFO":
      return {
        ...action,
      }
    default:
      return state
  }
}
export const initData = (state = initDataInfo, action: InitProps) => {
  switch (action.type) {
    case "SET_INIT_INFO":
      return {
        ...action,
      }
    default:
      return state
  }
}
export const userInfo = (state = InitUserInfo, action: UserProps) => {
  switch (action.type) {
    case "SET_USER_INFO":
      return {
        ...action,
      };
    default:
      return state;
  }
};
